// src/hooks/useModulePermissions.js
import { useState, useEffect } from 'react';

export const useModulePermissions = (moduleName) => {
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const getPermissions = () => {
      const storedPermissions = localStorage.getItem('userPermissions');
      if (storedPermissions) {
        const allPermissions = JSON.parse(storedPermissions);
        const modulePermissions = allPermissions.find(p => p.ModuleName === moduleName) || {};
        setPermissions(modulePermissions);
      }
    };

    getPermissions();
  }, [moduleName]);

  return permissions;
};